import React, { Component } from 'react'
import '../card.css'
import { setSize } from '../../../../store/actions/resultInfo'
import { connect } from 'react-redux'

class SizeIndicators extends Component {

    constructor(props) {
        super(props)
    }

    async handleClick() {
        await setSize(this.props.text1)
        this.props.history.push(`result?t=${this.props.resultInfo.mainType}&sh=${this.props.resultInfo.shape}&c=${this.props.resultInfo.color}&si=${this.props.resultInfo.size}
        `)
    }

    render() {
        return (
            <div onClick={() => this.handleClick()} className="size-indicater-outer-container" style={{ width: this.props.width, height: this.props.height }}>
                <div className="size-indicater-inner-container" style={{ width: this.props.width, height: this.props.height }}>
                    <div className="size-indicator-uplow">
                        <div className="size-indicater-upper-div"></div>
                        <span style={{ fontSize: this.props.px }}>{this.props.text1}</span>
                    </div>
                    <div className="size-indicator-uplow" >
                        <span style={{ fontSize: this.props.px }}>{this.props.text2}</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect((store) => ({ resultInfo: store.resultInfo }), {})(SizeIndicators)
